import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import { fetchFilterData } from "../../../utils/fetchFilterData";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../notification/Notification";
import { removeTransferFromCollection } from "../../../utils/collections";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ServicesSelect = ({
  checkedService,
  setCheckedService,
  isObject = true,
  defaultOption = false,
  rateService = false,
  selectName = null
}) => {
  const { t } = useTranslation("otherInterface");
  const [services, setServices] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [fetchingServices, setFetchingServices] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const filterData = {
    "rateService": rateService ? true : null,
    "pagination": false,
    "order[name]": "ASC"
  };

  const filterUrl = fetchFilterData(filterData);

  useEffect(() => {
    axios.get(`/api/services${filterUrl}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setServices(removeTransferFromCollection(response.data["hydra:member"]));
        setFetchingServices(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (forbidden) {
    return "Forbidden";
  }

  if (fetchingServices) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(services).length === 0) {
    return "Empty Services";
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <Autocomplete
          options={(isObject ? services : services.map(service => service.name)) || []}
          value={checkedService || null}
          onChange={(event, checkedService) => setCheckedService(checkedService)}
          getOptionLabel={(option) => isObject ? getServiceNameWithNickname(option.name, option.nickname) : option}
          renderInput={(params) => (
            <TextField {...params} label={selectName ? selectName : (rateService ? t("services.rateBaseService") : t("services.service"))} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default ServicesSelect;